import { SnLonLatBoundsLike, SnLonLatLike } from '@lib/geo/helpers';

export interface IGoogleGeocoderRequest {
  address?: string;
  lonLat?: SnLonLatLike;
  lonLatBounds?: SnLonLatBoundsLike;
  placeId?: string;
  region?: string;
  componentRestrictions?: google.maps.GeocoderComponentRestrictions;
}
